export default __webpack_public_path__ + "static/media/69_desktop.cba7d280.jpg";